import {
  POST_SURVEY,
  SET_FILTERED_SURVEYS,
  SET_COMPLETED_QUALIFIED_SURVEYS,
} from '../actions/actionTypes';

const INITIAL_STATE = {
  loading: false,
  surveys: [],
};
export const surveyReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case POST_SURVEY:
      return {
        ...state,
        body: action.payload,
        loading: false,
      };
    case SET_FILTERED_SURVEYS:
      return {
        ...state,
        surveys: action?.payload || {},
        loading: false,
        error: null,
      };
    case SET_COMPLETED_QUALIFIED_SURVEYS:
      return {
        ...state,
        completedQualifiedSurveys: action.payload.surveys || action.payload,
        loading: false,
        error: null,
      };
    default:
      return {
        ...state,
      };
  }
};
